import { useAuth } from "@auth/AuthContext"
import { Navigate } from "react-router-dom"

export function GuestRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth()
  return isAuthenticated ? <Navigate to="/" replace /> : <>{children}</>
}
